// import {CustomDropZone} from '@/components/custom_drop_zone';
import React, {useState} from 'react';

// import Mirt from 'react-mirt';
// import 'react-mirt/dist/css/react-mirt.css';

import Mirt from '@/components/react-mirt/src';

import './audio_trimmer.scss';

import springboard from 'springboard';

declare module 'springboard/module_registry/module_registry' {
    interface AllModules {
        AudioTrimmer: AudioTrimmerModuleReturnValue;
    }
}

type AudioTrimmerModuleReturnValue = {

};

type CurrentEditStatus = {
    start: number;
    current: number;
    end: number;
}

// const base64Audio =
//   "UklGRlgAAABXQVZFZm10IBAAAAABAAEAgLsAAAB3AQACABAAZGF0YQAAAAA=";

// // Convert Base64 to binary data
// const binaryString = atob(base64Audio);
// const len = binaryString.length;
// const bytes = new Uint8Array(len);

// for (let i = 0; i < len; i++) {
//   bytes[i] = binaryString.charCodeAt(i);
// }

// // Create an in-memory File object for the audio data
// const audioFile = new File([bytes], "validTestAudio.wav", {
//   type: "audio/wav",
//   lastModified: new Date().getTime(),
// });

springboard.registerModule('AudioTrimmer', {}, async (moduleAPI): Promise<AudioTrimmerModuleReturnValue> => {
    moduleAPI.registerRoute('', {}, () => {
        // const [file, setFile] = useState<File | null>(audioFile);
        const [file, setFile] = useState<File | null>(null);
        const [message, setMessage] = useState('');
        const [editStatus, setEditStatus] = useState<CurrentEditStatus | null>(null);

        const [playhead, setPlayhead] = useState<number | undefined>(undefined);

        return (
            <div>
                {/* <CustomDropZone
                    onDrop={files => {
                        const message = files.map(f => f.name).join(' ');
                        setMessage(message);
                        setFile(files[0]);
                    }}
                    onReject={files => {
                        const errorMessage = files.map(v => v.errors.map(e => e.message).join('. ')).join(' ');
                        setMessage(errorMessage);
                    }}
                /> */}
                <button
                    onClick={() => {
                        setPlayhead(5000)
                        setTimeout(() => {
                            setPlayhead(undefined)
                        })
                    }}
                >
                    set playhead
                </button>
                {message}
                {file && (
                    <>
                        <div className="trimmer-container">
                            <div className="trimmer">
                                <Mirt
                                    file={file}
                                    onChange={setEditStatus}
                                    style={{height: '100px', marginRight: '10px'}}
                                    options={{

                                    }}
                                    playhead={playhead || 0}
                                    isPlaying={false}
                                    onPlayClick={() => {

                                    }}
                                    onSeek={() => {

                                    }}
                                />
                            </div>
                            {editStatus && (
                                <div className="trimmer-text-container">
                                    <div className="trimmer-labels">
                                        <div className="trimmer-labels-below">
                                            <span>Length: {formatTime(editStatus.end - editStatus.start)}</span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                )
                }
            </div >
        );
    });

    return {};
});

const formatTime = (millis: number) => {
    const minutes = Math.floor(millis / (60 * 1000));
    const seconds = Math.floor((millis / (1000)) % 60);

    const secondsStr = seconds < 10 ? `0${seconds}` : `${seconds}`;

    return `${minutes}:${secondsStr}`;
};
